import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_31: FaireProductEntity = {
  token: "catalog_prod_prod-31",
  type: "product",
  name: "Textile Item",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop",
  priceDollars: 75.97,
  msrpDollars: 189.93,
  sku: "PA0031",
  caseSize: 6,
  material: "Cotton",
  collectionToken: "col_pattern-play",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 307,
  description: "Beautiful Pattern Play piece perfect for any home.",
  categoryTokens: ["catalog_cat_mens-accessories"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
